import React from 'react';

import MonthReportsPage from './MonthReportsPage';

export default function MonthReportsContainer() {
  return <MonthReportsPage />;
}
